module.exports = __webpack_public_path__ + "static/november-2-0c557117d24316f65c076f5c000863cd.jpg";